import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-media_small",
  "use": "icon-media_small-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-media_small\"><defs><style>#icon-media_small .a{fill:none;}#icon-media_small .b{fill:#505d6f;}</style></defs><path class=\"a\" d=\"M0,0H20V20H0Z\" /><path class=\"b\" d=\"M15.238,14.07l3.537,3.536-1.168,1.168L14.07,15.238a7.434,7.434,0,1,1,1.168-1.168Zm-1.657-.613a5.778,5.778,0,1,0-.124.124l.124-.124ZM6.129,8.606h6.606v1.652H6.129Z\" transform=\"translate(-0.25 -0.25)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol